import isString from 'lodash/isString';

/**
 * Check startsWith in array strings
 * @param value - string in which to search
 * @param searchStrings - array of search strings
 */
export const stringArrayStartsWith = (value: string, searchStrings: string[]): boolean => {
  if (!isString(value) || !Array.isArray(searchStrings)) {
    return false;
  }
  const lowerCaseValue = value.toLowerCase();
  return searchStrings.some((item) => isString(item) && lowerCaseValue.startsWith(item.toLowerCase()));
};

export const formatStringBySharpPattern = (value: string, pattern: string) => {
  let i = 0;
  // eslint-disable-next-line no-plusplus
  return pattern.replace(/#/g, () => value[i++]);
};

export const removeTags = (str: string | null): string => (str ? str.replace(/(<([^>]+)>)/gi, '') : '');
